import { setupExternalLinks } from './external-links.ts';
import { setupEmailLinks } from './email-links.ts';
import { setupFileLinks } from './file-links.ts';
import { setupModalToggles } from './modal-toggles.ts';
import { setupMenu } from './menu.ts';
import { setupModalA11y } from './modal-a11y.ts';
import { setupSearch } from './search.ts';
import { setupHeader } from './header.ts';

export function setup(): void {
    setupExternalLinks();
    setupEmailLinks();
    setupFileLinks();
    setupModalToggles();
    setupMenu();
    setupModalA11y();
    setupSearch();
    setupHeader();
}

// ---------------------------------------------------------------------------
// Legacy slider inits — carried over from index.js.
// These depend on commercial/vendored jQuery plugins (cslider, layerSlider,
// Revolution Slider) and are NOT called from setup(). Invoke manually when
// the relevant template loads its plugin scripts.
// ---------------------------------------------------------------------------

export function initParallaxSlider(): void {
    $(function () {
        // @ts-ignore — legacy cslider plugin, no type definition
        $('#da-slider').cslider();
    });
}

export function initLayerSlider(): void {
    $(document).ready(function () {
        // @ts-ignore — legacy layerSlider plugin, no type definition
        jQuery('#layerslider').layerSlider({
            skin: 'fullwidth',
            responsive: true,
            responsiveUnder: 960,
            layersContainer: 960,
            skinsPath: 'assets/plugins/layer-slider/layerslider/skins/',
        });
    });
}

export function initRevolutionSlider(): void {
    jQuery(document).ready(function () {
        // @ts-ignore — legacy Revolution Slider plugin, no type definition
        jQuery('.tp-banner').revolution({
            delay: 9000,
            startwidth: 1170,
            startheight: 500,
            hideThumbs: 10,
        });
    });
}
